
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/webview",
      function () {
        return require("private-next-pages/docs/link/webview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/webview"])
      });
    }
  